// extracted by mini-css-extract-plugin
export default {"page":"Auth_page__VH0eP","filter":"Auth_filter__nCskK","box":"Auth_box__3VwXQ"};